import { Link } from "react-router-dom";

const columns = [
  {
    title: "浏览",
    links: [
      { label: "首页", to: "/" },
      { label: "影视作品", to: "/works" },
      { label: "动态资讯", to: "/news" },
      { label: "全站搜索", to: "/search" },
    ],
  },
  {
    title: "作品分类",
    links: [
      { label: "电影作品", to: "/works?type=movie" },
      { label: "电视剧作品", to: "/works?type=series" },
      { label: "主演作品", to: "/works?role=主演" },
      { label: "最新作品", to: "/works?sort=latest" },
    ],
  },
  {
    title: "资料",
    links: [
      { label: "演员个人资料", to: "/profile" },
      { label: "关于本站", to: "/about" },
      { label: "使用说明", to: "/about#usage" },
      { label: "隐私说明", to: "/about#privacy" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-50">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 font-heading text-lg text-primary-950">
                翔
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-lg">翔田千里</span>
                <span className="mt-1 text-[9px] uppercase tracking-wider2 text-background-50/50">
                  Chisato Shoda Archive
                </span>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-xs leading-relaxed text-background-50/70">
              翔田千里影视作品与动态资讯整理站。收录电影、电视剧作品资料，以及访谈、活动与出版动态，供影迷与影视研究者查阅。本站不提供播放与下载服务。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2 text-[11px] text-background-50/50">
              <span className="rounded border border-background-50/20 px-2 py-1">前端演示站</span>
              <span className="rounded border border-background-50/20 px-2 py-1">资料整理</span>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="text-xs font-medium uppercase tracking-wider2 text-background-50/50">{column.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-50/75 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-background-50/10 pt-6 text-[11px] text-background-50/50 md:flex-row md:items-center md:justify-between">
          <p>© 2010–2026 翔田千里影视资料站 · 本站内容为演示用途，不涉及任何播放或下载服务。</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/about#privacy" className="transition-colors hover:text-accent-300">
              隐私说明
            </Link>
            <Link to="/about#usage" className="transition-colors hover:text-accent-300">
              使用说明
            </Link>
            <button
              type="button"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="flex cursor-pointer items-center gap-1 transition-colors hover:text-accent-300"
            >
              回到顶部
              <i className="ri-arrow-up-line" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}